<div class="list-item-container">
  <div class="content">
    <a [customRouterLink]="component.link" class="list-item">
      <div class="head">
        <div class="left">
          <div class="icon">
            <img
              lazyLoad="./assets/linked-apps/{{component.icon.toLowerCase()}}_linked_app.svg"
              defaultImage="./assets/linked-apps/{{component.icon.toLowerCase()}}_linked_app.svg"
              errorImage="./assets/ui/shared/error/not_found_error_image.png"
              src="#"
              alt="inked_app_icon_{{component.icon.toLowerCase()}}"
              title="inked_app_icon_{{component.icon.toLowerCase()}}" />
          </div>
          <div class="title">
            <kion-headline-tag
              [titleSize]="component.titleSize"
              [title]="component.title"
            ></kion-headline-tag>
            <div class="link">
              <a [customRouterLink]="component.link">{{component.link.url}}</a>
              <div class="linkPic">
                <img
                  src="./assets/icons/atom-icon-new-external-launch-big.svg"
                  alt="icon_atom-icon-new-external-launch-big.svg}"
                  title="icon_atom-icon-new-external-launch-big.svg}" />
              </div>
            </div>
          </div>
        </div>
        <div class="button">
          <ng-container [ngTemplateOutlet]="linkedButton"></ng-container>
        </div>
      </div>
      <div class="content-description">
        <div class="description">{{ component.content }}</div>
        <div class="phonebutton">
          <ng-container [ngTemplateOutlet]="linkedButton"></ng-container>
        </div>
      </div>
    </a>
  </div>
</div>
<ng-template #linkedButton>
  <kion-button
    [title]="component.buttonText"
    mode="linked-application"
    [disabled]="false"
    [isLoading]="false"
    [showTextWhileLoading]="true"
    [link]="component.link"
    (clicked)="true"
    isLink="true"
  ></kion-button>
</ng-template>
